var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPortal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "165px",
    height: "76.463px",
    viewBox: "0 0 165 76.463",
    enableBackground: "new 0 0 165 76.463",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M45.859,18.128c3.978,0,7.22,3.242,7.22,7.211 c0,3.965-3.242,7.211-7.22,7.211H33.145c-4.986,0-9.063,4.077-9.063,9.063c0,4.987,4.077,9.064,9.063,9.064H141.25 c4.982,0,9.06-4.077,9.06-9.064c0-4.986-4.077-9.063-9.06-9.063h-39.578c-3.97,0-7.211-3.246-7.211-7.211 c0-3.969,3.241-7.211,7.211-7.211h11.925c4.986,0,9.063-4.077,9.063-9.063c0-4.987-4.081-9.063-9.063-9.063H9.063 C4.081,0.001,0,4.078,0,9.064c0,4.986,4.077,9.063,9.063,9.063H45.859L45.859,18.128z M129.408,9.064 c0-4.987,4.077-9.063,9.063-9.063h17.465c4.982,0,9.063,4.081,9.063,9.063s-4.076,9.063-9.063,9.063h-3.526h-13.938 C133.485,18.128,129.408,14.051,129.408,9.064z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFCD2B",
    d: "M75.469,76.462c18.806,0,34.129-15.328,34.129-34.129 c0-18.797-15.323-34.128-34.129-34.128c-18.797,0-34.129,15.332-34.129,34.128C41.34,61.134,56.672,76.462,75.469,76.462z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#125F9A",
    d: "M120.804,0.001h-53.24c-1.571,0-2.854,1.277-2.854,2.853v49.432c0,1.579,1.282,2.853,2.854,2.853l0,0 h53.24c1.579,0,2.853-1.273,2.853-2.853l0,0V2.854C123.656,1.278,122.383,0.001,120.804,0.001z M67.563,1.899h53.24 c0.529,0,0.95,0.426,0.95,0.955v4.751H66.612V2.854C66.612,2.325,67.042,1.899,67.563,1.899z M120.804,53.241h-53.24 c-0.521,0-0.951-0.426-0.951-0.955V9.507h55.142v42.779C121.754,52.815,121.333,53.241,120.804,53.241z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#125F9A",
    d: "M68.515,3.801h1.901v1.906h-1.901V3.801z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#125F9A",
    d: "M72.318,3.801h1.902v1.906h-1.902V3.801z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#125F9A",
    d: "M76.122,3.801h1.902v1.906h-1.902V3.801z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#125F9A",
    d: "M88.478,28.502v0.021h0.033c3.357,2.535,7.996,2.535,11.354,0h0.025v-0.021 c4.201-3.151,5.053-9.109,1.901-13.31c-3.15-4.201-9.112-5.049-13.313-1.902c-4.201,3.151-5.053,9.109-1.902,13.314 C87.121,27.32,87.758,27.965,88.478,28.502z M90.379,27.493v-0.872c0-2.101,1.704-3.804,3.805-3.804s3.804,1.704,3.804,3.804 v0.872C95.639,28.862,92.728,28.862,90.379,27.493z M92.29,19.013c0-1.05,0.843-1.898,1.894-1.898 c1.05,0,1.901,0.848,1.901,1.898s-0.852,1.902-1.901,1.902C93.133,20.915,92.29,20.063,92.29,19.013z M94.184,13.307 c4.192,0,7.6,3.391,7.607,7.587c0,1.869-0.686,3.68-1.943,5.082c-0.206-1.84-1.29-3.46-2.91-4.35 c1.447-1.521,1.397-3.928-0.124-5.375c-1.521-1.452-3.929-1.398-5.384,0.124c-1.397,1.468-1.397,3.783,0,5.251 c-1.612,0.889-2.696,2.51-2.911,4.35c-2.804-3.125-2.539-7.926,0.587-10.726C90.495,13.993,92.307,13.307,94.184,13.307 L94.184,13.307z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#125F9A",
    d: "M81.82,32.323h-9.502c-0.529,0-0.951,0.426-0.951,0.951v5.706c0,0.525,0.422,0.951,0.951,0.951h9.502 c0.529,0,0.959-0.426,0.959-0.951v-5.706C82.779,32.749,82.35,32.323,81.82,32.323z M80.877,38.029H73.27v-3.805h7.607V38.029z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#125F9A",
    d: "M81.82,41.833h-9.502c-0.529,0-0.951,0.422-0.951,0.951v7.604c0,0.525,0.422,0.951,0.951,0.951h9.502 c0.529,0,0.959-0.426,0.959-0.951v-7.604C82.779,42.255,82.35,41.833,81.82,41.833z M80.877,49.433H73.27V43.73h7.607V49.433z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#125F9A",
    d: "M116.049,32.323H85.633c-0.529,0-0.959,0.426-0.959,0.951v5.706c0,0.525,0.43,0.951,0.959,0.951h30.416 c0.528,0,0.95-0.426,0.95-0.951v-5.706C116.999,32.749,116.577,32.323,116.049,32.323z M115.105,38.029h-28.53v-3.805h28.53 V38.029z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#125F9A",
    d: "M116.049,41.833H85.633c-0.529,0-0.959,0.422-0.959,0.951v7.604c0,0.525,0.43,0.951,0.959,0.951h30.416 c0.528,0,0.95-0.426,0.95-0.951v-7.604C116.999,42.255,116.577,41.833,116.049,41.833z M115.105,49.433h-28.53V43.73h28.53 V49.433z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#125F9A",
    d: "M88.478,45.637h1.901v1.898h-1.901V45.637z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#125F9A",
    d: "M92.29,45.637h1.894v1.898H92.29V45.637z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#125F9A",
    d: "M96.085,45.637h1.902v1.898h-1.902V45.637z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#125F9A",
    d: "M99.89,45.637h1.901v1.898H99.89V45.637z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#125F9A",
    d: "M103.693,45.637h1.902v1.898h-1.902V45.637z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#125F9A",
    d: "M107.489,45.637h1.91v1.898h-1.91V45.637z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#125F9A",
    d: "M111.302,45.637h1.901v1.898h-1.901V45.637z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortal);
export default __webpack_public_path__ + "static/media/portal.6b838bd1f0e01fc43ff4daab2024d908.svg";
export { ForwardRef as ReactComponent };